<template>
  <div class="page">
    <div style="display:flex;align-items:center;justify-content:space-between;gap:10px;flex-wrap:wrap;">
      <h2 class="page-title" style="margin:0;">{{ $t('menu.adminUsers') }}</h2>
      <el-button @click="load" :loading="loading">{{ $t('common.refresh') }}</el-button>
    </div>

    <div class="glass-card" style="margin-top:14px; padding:14px;">
      <el-tabs v-model="tab">
        <el-tab-pane :label="$t('admin.teams')" name="TEAM">
          <div style="display:flex;align-items:center;justify-content:space-between;gap:10px;margin-bottom:10px;flex-wrap:wrap;">
            <div class="muted" style="font-size:12px;">{{ teams.length }}</div>
            <el-button type="primary" class="btn-glass" @click="openCreateTeam">{{ $t('admin.createTeam') }}</el-button>
          </div>
          <el-table :data="teams" style="width:100%;">
            <el-table-column prop="id" label="ID" width="80" />
            <el-table-column prop="name" :label="$t('admin.teamName')" />
            <el-table-column prop="memberCount" :label="$t('admin.teamMembers')" width="140" />
            <el-table-column prop="createdAt" :label="$t('field.createdAt')" width="190">
              <template slot-scope="s">
                {{ s.row.createdAt ? new Date(s.row.createdAt).toLocaleString() : '-' }}
              </template>
            </el-table-column>
            <el-table-column :label="$t('common.actions')" width="220">
              <template slot-scope="s">
                <div class="action-buttons">
                  <el-button size="mini" @click="openEditTeam(s.row)">{{ $t('common.edit') }}</el-button>
                  <el-button size="mini" :disabled="saving" @click="deleteTeam(s.row)">{{ $t('common.delete') }}</el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>

        <el-tab-pane :label="$t('role.USER')" name="USER">
          <div style="display:flex;align-items:center;justify-content:space-between;gap:10px;margin-bottom:10px;flex-wrap:wrap;">
            <div class="muted" style="font-size:12px;">{{ userItems.length }}</div>
            <el-button type="primary" class="btn-glass" @click="openCreate('USER')">{{ $t('admin.create') }} {{ $t('role.USER') }}</el-button>
          </div>
          <el-table :data="userItemsPage" style="width:100%;">
            <el-table-column prop="id" label="ID" width="80" />
            <el-table-column prop="username" :label="$t('admin.username')" width="180" />
            <el-table-column prop="displayName" :label="$t('admin.displayName')" />
            <el-table-column prop="teamName" :label="$t('admin.team')" width="180">
              <template slot-scope="s">
                {{ s.row.teamName || '-' }}
              </template>
            </el-table-column>
            <el-table-column :label="$t('field.status')" width="220">
              <template slot-scope="s">
                <span v-if="s.row.locked" class="tag-pill tag-pill--warn" style="margin-right:10px;">{{ $t('admin.locked') }}</span>
                <span v-if="s.row.deletedAt" class="tag-pill tag-pill--danger" style="margin-right:10px;">{{ $t('admin.deleted') }}</span>
                <el-switch
                  v-model="s.row.enabled"
                  :disabled="!!s.row.deletedAt || saving"
                  @change="(val) => onSwitchEnabled(s.row, val)"
                />
              </template>
            </el-table-column>
            <el-table-column :label="$t('common.actions')" width="320">
              <template slot-scope="s">
                <div class="action-buttons">
                  <el-button size="mini" @click="openReset(s.row)">{{ $t('admin.resetPassword') }}</el-button>
                  <el-button size="mini" type="warning" :disabled="!!s.row.deletedAt || saving" @click="kick(s.row)">{{ $t('admin.kickOffline') }}</el-button>
                  <el-button size="mini" type="success" v-if="s.row.locked" :disabled="saving" @click="unlock(s.row)">{{ $t('admin.unlock') }}</el-button>
                  <el-button size="mini" :disabled="!!s.row.deletedAt" @click="softDelete(s.row)">{{ $t('admin.softDelete') }}</el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <div style="display:flex;justify-content:flex-end;margin-top:12px;">
            <el-pagination
              background
              layout="total, sizes, prev, pager, next"
              :total="userItems.length"
              :page-size="pageSizeUser"
              :current-page="pageUser"
              :page-sizes="[5,10,20,50]"
              @current-change="(p) => (pageUser = p)"
              @size-change="onUserSizeChange"
            />
          </div>
        </el-tab-pane>

        <el-tab-pane :label="$t('role.HANDLER')" name="HANDLER">
          <div style="display:flex;align-items:center;justify-content:space-between;gap:10px;margin-bottom:10px;flex-wrap:wrap;">
            <div class="muted" style="font-size:12px;">{{ handlerItems.length }}</div>
            <el-button type="primary" class="btn-glass" @click="openCreate('HANDLER')">{{ $t('admin.create') }} {{ $t('role.HANDLER') }}</el-button>
          </div>
          <el-table :data="handlerItemsPage" style="width:100%;">
            <el-table-column prop="id" label="ID" width="80" />
            <el-table-column prop="username" :label="$t('admin.username')" width="180" />
            <el-table-column prop="displayName" :label="$t('admin.displayName')" />
            <el-table-column :label="$t('field.status')" width="220">
              <template slot-scope="s">
                <span v-if="s.row.locked" class="tag-pill tag-pill--warn" style="margin-right:10px;">{{ $t('admin.locked') }}</span>
                <span v-if="s.row.deletedAt" class="tag-pill tag-pill--danger" style="margin-right:10px;">{{ $t('admin.deleted') }}</span>
                <el-switch
                  v-model="s.row.enabled"
                  :disabled="!!s.row.deletedAt || saving"
                  @change="(val) => onSwitchEnabled(s.row, val)"
                />
              </template>
            </el-table-column>
            <el-table-column :label="$t('common.actions')" width="320">
              <template slot-scope="s">
                <div class="action-buttons">
                  <el-button size="mini" @click="openReset(s.row)">{{ $t('admin.resetPassword') }}</el-button>
                  <el-button size="mini" type="warning" :disabled="!!s.row.deletedAt || saving" @click="kick(s.row)">{{ $t('admin.kickOffline') }}</el-button>
                  <el-button size="mini" type="success" v-if="s.row.locked" :disabled="saving" @click="unlock(s.row)">{{ $t('admin.unlock') }}</el-button>
                  <el-button size="mini" :disabled="!!s.row.deletedAt" @click="softDelete(s.row)">{{ $t('admin.softDelete') }}</el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <div style="display:flex;justify-content:flex-end;margin-top:12px;">
            <el-pagination
              background
              layout="total, sizes, prev, pager, next"
              :total="handlerItems.length"
              :page-size="pageSizeHandler"
              :current-page="pageHandler"
              :page-sizes="[5,10,20,50]"
              @current-change="(p) => (pageHandler = p)"
              @size-change="onHandlerSizeChange"
            />
          </div>
        </el-tab-pane>

        <el-tab-pane :label="$t('role.SECONDARY_HANDLER')" name="SECONDARY_HANDLER">
          <div style="display:flex;align-items:center;justify-content:space-between;gap:10px;margin-bottom:10px;flex-wrap:wrap;">
            <div class="muted" style="font-size:12px;">{{ secondaryHandlerItems.length }}</div>
            <el-button type="primary" class="btn-glass" @click="openCreate('SECONDARY_HANDLER')">{{ $t('admin.create') }} {{ $t('role.SECONDARY_HANDLER') }}</el-button>
          </div>
          <el-table :data="secondaryHandlerItemsPage" style="width:100%;">
            <el-table-column prop="id" label="ID" width="80" />
            <el-table-column prop="username" :label="$t('admin.username')" width="180" />
            <el-table-column prop="displayName" :label="$t('admin.displayName')" />
            <el-table-column prop="caseNoPrefix" :label="$t('admin.caseNoPrefix')" width="140">
              <template slot-scope="s">
                {{ s.row.caseNoPrefix || '-' }}
              </template>
            </el-table-column>
            <el-table-column :label="$t('field.status')" width="220">
              <template slot-scope="s">
                <span v-if="s.row.locked" class="tag-pill tag-pill--warn" style="margin-right:10px;">{{ $t('admin.locked') }}</span>
                <span v-if="s.row.deletedAt" class="tag-pill tag-pill--danger" style="margin-right:10px;">{{ $t('admin.deleted') }}</span>
                <el-switch
                  v-model="s.row.enabled"
                  :disabled="!!s.row.deletedAt || saving"
                  @change="(val) => onSwitchEnabled(s.row, val)"
                />
              </template>
            </el-table-column>
            <el-table-column :label="$t('common.actions')" width="320">
              <template slot-scope="s">
                <div class="action-buttons">
                  <el-button size="mini" @click="openPrefix(s.row)">{{ $t('admin.setCaseNoPrefix') }}</el-button>
                  <el-button size="mini" @click="openReset(s.row)">{{ $t('admin.resetPassword') }}</el-button>
                  <el-button size="mini" type="warning" :disabled="!!s.row.deletedAt || saving" @click="kick(s.row)">{{ $t('admin.kickOffline') }}</el-button>
                  <el-button size="mini" type="success" v-if="s.row.locked" :disabled="saving" @click="unlock(s.row)">{{ $t('admin.unlock') }}</el-button>
                  <el-button size="mini" :disabled="!!s.row.deletedAt" @click="softDelete(s.row)">{{ $t('admin.softDelete') }}</el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <div style="display:flex;justify-content:flex-end;margin-top:12px;">
            <el-pagination
              background
              layout="total, sizes, prev, pager, next"
              :total="secondaryHandlerItems.length"
              :page-size="pageSizeSecondaryHandler"
              :current-page="pageSecondaryHandler"
              :page-sizes="[5,10,20,50]"
              @current-change="(p) => (pageSecondaryHandler = p)"
              @size-change="onSecondaryHandlerSizeChange"
            />
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>

    <el-dialog
      :title="createTitle"
      :visible.sync="createDialog"
      width="520px"
      :modal="false"
      :lock-scroll="false"
      :close-on-click-modal="false"
    >
      <el-form :model="createForm" label-position="top">
        <el-form-item :label="$t('admin.username')">
          <el-input v-model="createForm.username" />
        </el-form-item>
        <el-form-item :label="$t('admin.displayName')">
          <el-input v-model="createForm.displayName" />
        </el-form-item>
        <el-form-item :label="$t('admin.password')">
          <PasswordInput v-model="createForm.password" autocomplete="new-password" />
        </el-form-item>
        <el-form-item v-if="createRole==='USER'" :label="$t('admin.team')">
          <el-select v-model="createForm.teamId" clearable filterable style="width:100%;">
            <el-option
              v-for="t in teams"
              :key="t.id"
              :value="t.id"
              :label="t.name"
            />
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="createDialog=false">{{ $t('common.cancel') }}</el-button>
        <el-button type="primary" class="btn-glass" :loading="saving" @click="create">{{ $t('common.confirm') }}</el-button>
      </span>
    </el-dialog>

    <el-dialog
      :title="$t('admin.resetPassword')"
      :visible.sync="resetDialog"
      width="520px"
      :modal="false"
      :lock-scroll="false"
      :close-on-click-modal="false"
    >
      <el-form :model="resetForm" label-position="top">
        <el-form-item :label="$t('admin.username')">
          <el-input :value="resetTarget ? resetTarget.username : ''" disabled />
        </el-form-item>
        <el-form-item :label="$t('admin.password')">
          <PasswordInput v-model="resetForm.newPassword" autocomplete="new-password" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="resetDialog=false">{{ $t('common.cancel') }}</el-button>
        <el-button type="primary" class="btn-glass" :loading="saving" @click="reset">{{ $t('common.confirm') }}</el-button>
      </span>
    </el-dialog>

    <el-dialog
      :title="$t('admin.softDelete')"
      :visible.sync="deleteDialog"
      width="520px"
      :modal="false"
      :lock-scroll="false"
      :close-on-click-modal="false"
    >
      <div class="muted">{{ $t('admin.softDelete') }}: {{ deleteTarget ? deleteTarget.username : '' }}</div>
      <div class="muted" style="margin-top: 8px;">
        {{ $t('admin.softDeleteHint') }}
      </div>
      <span slot="footer">
        <el-button @click="deleteDialog=false">{{ $t('common.cancel') }}</el-button>
        <el-button type="primary" class="btn-glass" :loading="saving" @click="doSoftDelete">{{ $t('common.confirm') }}</el-button>
      </span>
    </el-dialog>

    <el-dialog
      :title="teamForm.id ? $t('admin.editTeam') : $t('admin.createTeam')"
      :visible.sync="teamDialog"
      width="620px"
      :modal="false"
      :lock-scroll="false"
      :close-on-click-modal="false"
    >
      <el-form :model="teamForm" label-position="top">
        <el-form-item :label="$t('admin.teamName')">
          <el-input v-model="teamForm.name" />
        </el-form-item>
        <el-form-item :label="$t('admin.teamMembers')">
          <el-select v-model="teamForm.userIds" multiple filterable style="width:100%;">
            <el-option
              v-for="u in userItems"
              :key="u.id"
              :value="u.id"
              :label="`${u.displayName || u.username} (${u.username})`"
            />
          </el-select>
        </el-form-item>
        <el-form-item v-if="createRole==='SECONDARY_HANDLER'" :label="$t('admin.caseNoPrefix')">
          <el-input v-model="createForm.caseNoPrefix" maxlength="6" :placeholder="$t('admin.caseNoPrefixPlaceholder')" @input="onPrefixInput('createForm')" />
          <div class="muted" style="font-size:12px;margin-top:6px;">{{ $t('admin.caseNoPrefixHint') }}</div>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="teamDialog=false">{{ $t('common.cancel') }}</el-button>
        <el-button type="primary" class="btn-glass" :loading="saving" @click="saveTeam">{{ $t('common.confirm') }}</el-button>
      </span>
    </el-dialog>

    <el-dialog
      :title="$t('admin.setCaseNoPrefix')"
      :visible.sync="prefixDialog"
      width="520px"
      :modal="false"
      :lock-scroll="false"
      :close-on-click-modal="false"
    >
      <el-form :model="prefixForm" label-position="top">
        <el-form-item :label="$t('admin.username')">
          <el-input :value="prefixTarget ? prefixTarget.username : ''" disabled />
        </el-form-item>
        <el-form-item :label="$t('admin.caseNoPrefix')">
          <el-input v-model="prefixForm.caseNoPrefix" maxlength="6" :placeholder="$t('admin.caseNoPrefixPlaceholder')" @input="onPrefixInput('prefixForm')" />
          <div class="muted" style="font-size:12px;margin-top:6px;">{{ $t('admin.caseNoPrefixHint') }}</div>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="prefixDialog=false">{{ $t('common.cancel') }}</el-button>
        <el-button type="primary" class="btn-glass" :loading="saving" @click="savePrefix">{{ $t('common.confirm') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  adminListUsers,
  adminCreateUser,
  adminResetPassword,
  adminSetUserEnabled,
  adminSoftDeleteUser,
  adminKickUser,
  adminUnlockUser,
  adminSetCaseNoPrefix,
  adminListTeams,
  adminCreateTeam,
  adminSetTeamMembers,
  adminDeleteTeam
} from '../../api/admin';
import PasswordInput from '../../components/PasswordInput.vue';

export default {
  name: 'AdminUsers',
  components: { PasswordInput },
  data() {
    return {
      loading: false,
      items: [],
      teams: [],
      saving: false,
      tab: 'USER',
      pageUser: 1,
      pageSizeUser: 10,
      pageHandler: 1,
      pageSizeHandler: 10,
      pageSecondaryHandler: 1,
      pageSizeSecondaryHandler: 10,
      createDialog: false,
      createRole: 'USER',
      createForm: { username: '', displayName: '', role: 'USER', password: '', teamId: null, caseNoPrefix: '' },
      prefixDialog: false,
      prefixTarget: null,
      prefixForm: { caseNoPrefix: '' },
      resetDialog: false,
      resetTarget: null,
      resetForm: { newPassword: '' },
      deleteDialog: false,
      deleteTarget: null,
      teamDialog: false,
      teamForm: { id: null, name: '', userIds: [] }
    };
  },
  created() {
    this.load();
  },
  computed: {
    userItems() {
      return (this.items || []).filter((x) => x && x.role === 'USER');
    },
    userItemsPage() {
      const start = (this.pageUser - 1) * this.pageSizeUser;
      return this.userItems.slice(start, start + this.pageSizeUser);
    },
    handlerItems() {
      return (this.items || []).filter((x) => x && x.role === 'HANDLER');
    },
    handlerItemsPage() {
      const start = (this.pageHandler - 1) * this.pageSizeHandler;
      return this.handlerItems.slice(start, start + this.pageSizeHandler);
    },
    secondaryHandlerItems() {
      return (this.items || []).filter((x) => x && x.role === 'SECONDARY_HANDLER');
    },
    secondaryHandlerItemsPage() {
      const start = (this.pageSecondaryHandler - 1) * this.pageSizeSecondaryHandler;
      return this.secondaryHandlerItems.slice(start, start + this.pageSizeSecondaryHandler);
    },
    createTitle() {
      return `${this.$t('admin.create')} ${this.$t(`role.${this.createRole}`)}`;
    }
  },
  methods: {
    async load() {
      this.loading = true;
      try {
        const [users, teams] = await Promise.all([adminListUsers(), adminListTeams()]);
        this.items = users || [];
        this.teams = teams || [];
        // keep current page in range after data changes
        const maxUser = Math.max(1, Math.ceil(this.userItems.length / this.pageSizeUser));
        const maxHandler = Math.max(1, Math.ceil(this.handlerItems.length / this.pageSizeHandler));
        const maxSecondaryHandler = Math.max(1, Math.ceil(this.secondaryHandlerItems.length / this.pageSizeSecondaryHandler));
        this.pageUser = Math.min(this.pageUser, maxUser);
        this.pageHandler = Math.min(this.pageHandler, maxHandler);
        this.pageSecondaryHandler = Math.min(this.pageSecondaryHandler, maxSecondaryHandler);
      } finally {
        this.loading = false;
      }
    },
    onUserSizeChange(s) {
      this.pageSizeUser = s;
      this.pageUser = 1;
    },
    onHandlerSizeChange(s) {
      this.pageSizeHandler = s;
      this.pageHandler = 1;
    },
    onSecondaryHandlerSizeChange(s) {
      this.pageSizeSecondaryHandler = s;
      this.pageSecondaryHandler = 1;
    },
    openCreate(role) {
      this.createRole = role || 'USER';
      this.createForm = { username: '', displayName: '', role: this.createRole, password: '', teamId: null, caseNoPrefix: '' };
      this.createDialog = true;
    },
    onPrefixInput(formName) {
      const form = this[formName];
      if (!form) return;
      form.caseNoPrefix = String(form.caseNoPrefix || '').toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 6);
    },
    openCreateTeam() {
      this.teamForm = { id: null, name: '', userIds: [] };
      this.teamDialog = true;
    },
    openEditTeam(row) {
      if (!row) return;
      this.teamForm = {
        id: row.id,
        name: row.name,
        userIds: this.userItems.filter((u) => u.teamId === row.id).map((u) => u.id)
      };
      this.teamDialog = true;
    },
    async saveTeam() {
      if (!this.teamForm.name) return this.$message.error(this.$t('common.required'));
      this.saving = true;
      try {
        if (this.teamForm.id) {
          await adminSetTeamMembers(this.teamForm.id, { name: this.teamForm.name, userIds: this.teamForm.userIds });
        } else {
          await adminCreateTeam({ name: this.teamForm.name, userIds: this.teamForm.userIds });
        }
        this.teamDialog = false;
        await this.load();
      } finally {
        this.saving = false;
      }
    },
    async deleteTeam(row) {
      if (!row) return;
      try {
        await this.$confirm(this.$t('admin.deleteTeamConfirm'), this.$t('common.delete'), {
          confirmButtonText: this.$t('common.confirm'),
          cancelButtonText: this.$t('common.cancel'),
          type: 'warning'
        });
      } catch (e) {
        return;
      }
      this.saving = true;
      try {
        await adminDeleteTeam(row.id);
        await this.load();
      } finally {
        this.saving = false;
      }
    },
    async create() {
      if (!this.createForm.username || !this.createForm.password) return this.$message.error(this.$t('common.required'));
      this.saving = true;
      try {
        await adminCreateUser(this.createForm);
        this.createDialog = false;
        await this.load();
      } catch (e) {
        // axios interceptor shows the message; keep the dialog open.
      } finally {
        this.saving = false;
      }
    },
    openPrefix(row) {
      if (!row) return;
      this.prefixTarget = row;
      this.prefixForm.caseNoPrefix = row.caseNoPrefix || '';
      this.prefixDialog = true;
    },
    async savePrefix() {
      if (!this.prefixTarget) return;
      this.saving = true;
      try {
        await adminSetCaseNoPrefix(this.prefixTarget.id, { caseNoPrefix: this.prefixForm.caseNoPrefix || null });
        this.prefixDialog = false;
        this.prefixTarget = null;
        await this.load();
      } finally {
        this.saving = false;
      }
    },
    async onSwitchEnabled(row, enabled) {
      if (!row) return;
      const prev = !enabled;
      this.saving = true;
      try {
        await adminSetUserEnabled(row.id, { enabled: !!enabled });
        await this.load();
      } catch (e) {
        // Revert UI if request fails.
        row.enabled = prev;
      } finally {
        this.saving = false;
      }
    },
    softDelete(row) {
      if (!row) return;
      this.deleteTarget = row;
      this.deleteDialog = true;
    },
    async doSoftDelete() {
      if (!this.deleteTarget) return;
      this.saving = true;
      try {
        await adminSoftDeleteUser(this.deleteTarget.id);
        await this.load();
        this.deleteDialog = false;
        this.deleteTarget = null;
      } finally {
        this.saving = false;
      }
    },
    async kick(row) {
      if (!row) return;
      try {
        await this.$confirm(this.$t('admin.kickOfflineConfirm'), this.$t('admin.kickOffline'), {
          confirmButtonText: this.$t('common.confirm'),
          cancelButtonText: this.$t('common.cancel'),
          type: 'warning'
        });
      } catch (e) {
        return;
      }
      this.saving = true;
      try {
        await adminKickUser(row.id);
        await this.load();
      } finally {
        this.saving = false;
      }
    },
    async unlock(row) {
      if (!row || !row.locked) return;
      try {
        await this.$confirm(this.$t('admin.unlockConfirm'), this.$t('admin.unlock'), {
          confirmButtonText: this.$t('common.confirm'),
          cancelButtonText: this.$t('common.cancel'),
          type: 'warning'
        });
      } catch (e) {
        return;
      }
      this.saving = true;
      try {
        await adminUnlockUser(row.id);
        await this.load();
      } finally {
        this.saving = false;
      }
    },

    openReset(row) {
      this.resetTarget = row;
      this.resetForm.newPassword = '';
      this.resetDialog = true;
    },
    async reset() {
      if (!this.resetTarget) return;
      if (!this.resetForm.newPassword) return this.$message.error(this.$t('common.required'));
      this.saving = true;
      try {
        await adminResetPassword(this.resetTarget.id, { newPassword: this.resetForm.newPassword });
        this.resetDialog = false;
        this.resetTarget = null;
      } finally {
        this.saving = false;
      }
    }
  }
};
</script>

<style scoped>
.action-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
}

.action-buttons .el-button + .el-button {
  margin-left: 0;
}
</style>
